import React, { useState } from "react";
import axios from "axios";
import { marked } from "marked"; // Import marked for Markdown to HTML conversion
import '../resume.css';

const ResumeUploader = () => {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a resume file first.");
      return;
    }

    setLoading(true); // Set loading state to true when starting upload
    setStatus(null); // Clear previous status

    const formData = new FormData();
    formData.append("resume", file);

    try {
      const response = await axios.post("https://atsbackend-83j3.onrender.com/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const { ATS_Score, Improvement_Areas, Strengths, Weaknesses, Objective_Evaluation } = response.data.analysis;
      console.log("Frontend API Response:", response.data.analysis);

      console.log(" ATS SCORE",response.data.analysis.ATS_Score) 
      console.log("strenght ",response.data.analysis.Strengths) 
      // Convert the Objective_Evaluation Markdown string to HTML
      const objectiveEvaluationHTML = Objective_Evaluation ? marked(Objective_Evaluation) : "No evaluation provided";

      setStatus({
        atsScore: ATS_Score || "N/A",
        improvementAreas: Improvement_Areas || "No suggestions for improvement",
        strengths: Array.isArray(Strengths) ? Strengths : ["No strengths listed."],
        weaknesses: Array.isArray(Weaknesses) ? Weaknesses : ["No weaknesses listed."],
        objectiveEvaluation: objectiveEvaluationHTML,
      });
    } catch (error) {
      console.error("Error uploading file:", error);
      setStatus({ atsScore: "Error", improvementAreas: "Error", strengths: [], weaknesses: [] });
    } finally {
      setLoading(false); // Set loading state to false once the process is done
    }
  };

  return (
    <div className="p-5 max-w-md mx-auto bg-white rounded-xl shadow-md space-y-4">
      <h2 className="text-xl font-bold text-center">Upload Your Resume</h2>

      {/* Resume file input */}
      <input
        type="file"
        accept=".pdf,.doc,.docx"
        onChange={handleFileChange}
        className="border p-2 w-full"
        disabled={loading} // Disable input while loading
      />

      {/* Upload button */}
      <button
        onClick={handleUpload}
        className="bg-blue-500 text-white px-4 py-2 rounded-lg mt-4 w-full"
        disabled={loading || !file} // Disable button if no file is selected or during loading
      >
        {loading ? "Uploading..." : "Upload"}
      </button>

      {/* Display analysis results */}
      {status && (
        <div className="mt-5 space-y-4">
          {/* ATS Score Card */}
          <div className="card bg-gray-100 p-4 rounded-lg shadow-md">
            <h3 className="text-lg font-semibold text-blue-700">ATS Score</h3>
            <p>{status.atsScore}</p>
          </div>

          {/* Strengths Section */}
          {/* <div className="card bg-green-100 p-4 rounded-lg shadow-md">
            <h3 className="text-lg font-semibold text-green-700">Strengths</h3>
            <ul className="list-disc pl-5 mt-2">
              {status.strengths.map((strength, index) => (
                <li key={index} className="mt-2 text-green-600">{strength}</li>
              ))}
            </ul>
          </div> */}

          {/* Weaknesses Section */}
          {/* <div className="card bg-red-100 p-4 rounded-lg shadow-md">
            <h3 className="text-lg font-semibold text-red-700">Weaknesses</h3>
            <ul className="list-disc pl-5 mt-2">
              {status.weaknesses.map((weakness, index) => (
                <li key={index} className="mt-2 text-red-600">{weakness}</li>
              ))}
            </ul>
          </div> */}

          {/* Objective Evaluation Section - Rendered HTML */}
          {/* <div className="card bg-yellow-100 p-4 rounded-lg shadow-md">
            <h3 className="text-lg font-semibold text-yellow-700">Objective Evaluation</h3>
            <div
              className="mt-2"
              dangerouslySetInnerHTML={{ __html: status.objectiveEvaluation }} // Render the HTML here
            />
          </div> */}

          {/* Improvement Areas Section */}
          {/* <div className="card bg-yellow-100 p-4 rounded-lg shadow-md">
            <h3 className="text-lg font-semibold text-yellow-700">Improvement Areas</h3>
            <p>{status.improvementAreas}</p>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default ResumeUploader;
